/*
* @Author: zhangzhitao
* @Date: 2019-10-09 14:31:41
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-10-14 10:45:22
*/

<template>
  <div class="m-login-style">
    <div class="m-group-header">{{$t('management.login.web_config')}}</div>
    <el-form
      label-position="top"
      :model="form"
    >
      <el-form-item
        :description="$t('management.login.config_tips1')"
        :label="$t('management.login.before_login_web')"
        prop="indexUrlBeforeLogin"
      >
        <el-input v-model="form.indexUrlBeforeLogin"></el-input>
      </el-form-item>
      <el-form-item
        :description="$t('management.login.config_tips2')"
        :label="$t('management.login.after_login_web')"
        prop="indexUrlAfterLogin"
      >
        <el-input v-model="form.indexUrlAfterLogin"></el-input>
      </el-form-item>
    </el-form>
    <div class="m-foot-bar">
      <el-button
        type="primary"
        @click="_setUrls"
      >{{$t('management.login.save')}}</el-button>
    </div>
  </div>
</template>

<script>
import API from 'api/api'
import { max2048ChartRule } from '@/utils/validator'
export default {
  name: 'redirect',
  data () {
    return {
      form: {
        indexUrlBeforeLogin: '',
        indexUrlAfterLogin: ''
      },
      formRule: {
        indexUrlBeforeLogin: [max2048ChartRule],
        indexUrlAfterLogin: [max2048ChartRule]
      }
    }
  },

  components: {},

  computed: {},

  mounted () {
    this._getUrls()
  },

  methods: {
    _getUrls () {
      API.login.getLoginUrls().then(res => {
        this.form = res.data || {
          indexUrlBeforeLogin: '',
          indexUrlAfterLogin: ''
        }
      })
    },
    _setUrls () {
      API.login.saveLoginUrls(this.form).then(res => {
        this.$message.success(this.$t('management.login.save_success'))
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.m-login-style {
  width: 1056px;
  margin: 0 auto;
  overflow: hidden;
  padding: 36px;
  img {
    margin-left: 36px;
    cursor: pointer;
    border-radius: 4px;
    border: 2px solid transparent;
    :hover {
      border: 2px solid transparent;
    }
  }
  .m-foot-bar {
    margin-top: 48px;
    padding-left: 0px !important;
  }
}
.m-group-header {
  width: 100%;
  height: 26px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 16px;
  text-indent: 0px !important;
}
</style>
